import React from "react";
interface props {
  className?: string;
}

function Icon8({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 42 43"
    >
      <circle cx="21" cy="21.059" r="20.5" stroke="#FF752C"></circle>
      <path
        stroke="#FF752C"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.998 11c-2.85 0-4.697 2.02-6.882 2.755-.888.3-1.333.449-1.512.66-.18.21-.233.519-.338 1.135-1.127 6.596 1.336 12.694 7.209 15.068.631.255.947.382 1.526.382.579 0 .896-.127 1.527-.382 5.873-2.374 8.333-8.472 7.206-15.068-.106-.616-.158-.924-.338-1.135-.18-.211-.624-.36-1.512-.66C25.698 13.02 23.848 11 20.998 11z"
      ></path>
      <path
        stroke="#FF752C"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.833 21.167c1.055 1.055 2.445 2.127 2.445 2.127l1.905-1.905s-1.072-1.39-2.127-2.445c-1.055-1.055-2.445-2.127-2.445-2.127l-1.905 1.905s1.072 1.39 2.127 2.445zm0 0L17.5 24.5m8-3.429l-2.54 2.54M20.93 16.5l-2.54 2.54"
      ></path>
    </svg>
  );
}

export default Icon8;
